import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore/lite';

const firebaseConfig = {
    apiKey: "AIzaSyD-Hn7_oZeYOKDiKcZrsImeV1Vo1sk-UdM",
    authDomain: "ans-designs.firebaseapp.com",
    projectId: "ans-designs",
    storageBucket: "ans-designs.firebasestorage.app",
    messagingSenderId: "983236228123",
    appId: "1:983236228123:web:0ab4ff9b3562a72b6074be",
    measurementId: "G-4SKKSBCY13"
};

let app;

export function initFirebase() {
    app = initializeApp(firebaseConfig);
}

export function getFirebaseBD() {
    return getFirestore(app);
}